import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.pocketEntry || initialState;

export const selectPocketEntry = createSelector([selectSlice], state => state);

export const selectPocketEntryReport = createSelector(
  [selectSlice],
  state => state.entry,
);
